import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { PRIMARY_NAV } from './navConfig';
import { useSession } from '../context/SessionContext';
import './MobileBottomNav.less';

function MobileBottomNav() {
  const { pathname } = useLocation();
  const session = useSession();
  const activeSessionUid = session?.state?.sessionUid || null;

  return (
    <nav className="gc-mobile-nav" aria-label="Primary">
      <ul className="gc-mobile-nav-list">
        {PRIMARY_NAV.map((item) => {
          const isActive = item.match(pathname);
          const isCharge = item.key === 'charge';
          const to = isCharge && activeSessionUid ? '/charge/active' : item.to;
          const Icon = item.icon;
          return (
            <li key={item.key} className="gc-mobile-nav-item">
              <NavLink
                to={to}
                end={item.key === 'home'}
                className={({ isActive: linkActive }) =>
                  `gc-mobile-nav-link${(isActive || linkActive) ? ' is-active' : ''}`
                }
                aria-current={isActive ? 'page' : undefined}
              >
                <span className="gc-mobile-nav-icon" aria-hidden="true">
                  <Icon />
                  {isCharge && activeSessionUid && <span className="gc-mobile-nav-dot" />}
                </span>
                <span className="gc-mobile-nav-label">
                  {isCharge && activeSessionUid
                    ? 'Active'
                    : (item.mobileLabel || item.label)}
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}

export default MobileBottomNav;
